import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Grid,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Link as DomLink } from "react-router-dom";
import * as Yup from "yup";
import { getAllImagesAndUrl } from "../../../pages/BookingDashboard/apis/BrandingModalApi";
import { getHotel, login, masterLogin, masterLoginV2, masterLoginV2Otp, hotelLoginV2 } from "../_redux/authCrud";
import * as auth from "../_redux/authRedux";
import { formatDisplayTimeForOtpEpoch } from "../../../Utils/Utils";

const EmailSuccess = (props) => {
  const LoginSchema = Yup.object().shape({
    passw: Yup.string().required("Password is required"),
  });
  const MasterLoginSchema = Yup.object().shape({
    username: Yup.string().required("master email is required"),
    passw: Yup.string().required("master password is required"),
  });
  const masterAdminCheck =
    window.location.pathname.split("/")[1] === "masterAdmin" ? true : false;
  // const theme = useTheme()
  // const matches = useMediaQuery('(min-width:600px)');
  const [loading, setLoading] = useState(false);
  const [invalid, setInvalid] = useState(false);
  const [invalidLogin, setInvalidLogin] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // v2 auth check 
  const { isV2AuthEnabled, loginTrue, mailId } = props; 
  const [authErrorMessage, setAuthErrorMessage] = useState("");

  // State for otp flow
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpId, setOtpId] = useState("");
  const [otpExpiresAt, setOtpExpiresAt] = useState(0);
  const [timerTick, setTimerTick] = useState(0);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpAttempts, setOtpAttempts] = useState(0);
  const [otpInvalid, setOtpInvalid] = useState(false);

  const formik = useFormik({
    initialValues: { passw: "" },
    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      validUser(values);
    },
  });

  const masterFormik = useFormik({
    initialValues: { username: "", passw: "" },
    validationSchema: MasterLoginSchema,
    onSubmit: async (values) => {
      validMasterUser(values);
    },
  });

  const validMasterUser = async (values) => {
    setLoading(true);
    setInvalid(false);
    setAuthErrorMessage("");

    // Reset OTP states before starting new flow
    setOtpVerified(false); 
    setOtpValue("");
    setOtpId("");
    setOtpExpiresAt(0);
    setOtpAttempts(0);
    setOtpInvalid(false);
    
    try {
      const temporary = await masterLoginV2(
        mailId,
        values.username,
        values.passw
      );
      let resp = temporary.data;
      
      setOtpId(resp?.otpid);
      setOtpExpiresAt(resp?.otpExpiresAt || 0);
      setOtpVerified(true);
      setLoading(false);
    } catch (e) {
      setInvalid(true);
      setLoading(false);
      setAuthErrorMessage(e?.response?.data?.message || "Something went wrong, couldn't send the OTP");
    }
  };

  const handleOtpSignIn = async () => {
    if (!otpValue.trim()) {
      setOtpInvalid(true);
      return;
    }
    setOtpLoading(true);
    setOtpInvalid(false);
    try {
      const otpResponse = await masterLoginV2Otp(otpId, otpValue);
      let resp = otpResponse.data;

      const hotelData = await getHotel(
        mailId,
        resp.groupProperty,
        `${resp.token}`
      );
      const temp = Object.assign(resp);
      temp.hotels = hotelData.data;
      temp.email = mailId;
      temp.token = `${resp.token}`;
      localStorage.setItem("hotelId", hotelData.data[0].hotelId);
      localStorage.setItem("token", `${resp.token}`);
      localStorage.setItem("rootEmail", masterFormik.values.username);
      
      setOtpLoading(false);
      props.login(temp);
      localStorage.setItem("HotelEmail", mailId);
    } catch (e) {
      const newAttempts = otpAttempts + 1;
      setOtpAttempts(newAttempts);
      setOtpLoading(false);
      setOtpInvalid(true);
      setOtpValue("");

      if (newAttempts >= 3) {
        setOtpVerified(false);
        setOtpId("");
        setOtpExpiresAt(0);
        setOtpValue("");
        setOtpAttempts(0);
        setOtpInvalid(false);
      }
    }
  };

  const validUser = async (values) => {
    setLoading(true);
    setInvalid(false);
    setInvalidLogin(false);
    setAuthErrorMessage("");

    // Reset OTP states before starting new flow
    setOtpVerified(false);
    setOtpValue("");
    setOtpId("");
    setOtpExpiresAt(0);
    setOtpAttempts(0);
    setOtpInvalid(false);

    try {
      if (isV2AuthEnabled) {
        const temporary = await hotelLoginV2(mailId, values.passw);
        let resp = temporary.data;
        
        setOtpId(resp?.otpid);
        setOtpExpiresAt(resp?.otpExpiresAt || 0);
        setOtpVerified(true);
        setOtpAttempts(0);
        setOtpInvalid(false);
        setInvalid(false);
        setLoading(false);
      } else {
        const temporary = await login(mailId, values.passw);
        localStorage.setItem("HotelEmail", mailId);
        if (temporary.data.token === "Invalid login hours") {
          setInvalidLogin(true);
          setLoading(false);
        } else {
          const resp = temporary.data;
          const hotelData = await getHotel(
            mailId,
            resp.groupProperty,
            resp.token
          );
          const temp = Object.assign(resp);
          temp.hotels = hotelData.data;
          temp.email = mailId;
          localStorage.setItem("hotelId", hotelData.data[0].hotelId);
          localStorage.setItem("token", resp.token);
          setLoading(false);
          props.login(temp);
          localStorage.setItem("HotelEmail", mailId);
        }
      }
    } catch (e) {
      setInvalid(true);
      setLoading(false);
      // Add detailed error message
      setAuthErrorMessage(e?.response?.data?.message || "Something went wrong, couldn't send the OTP");
    }
  };

  const [showHelper, setshowHelper] = useState("");
  useEffect(async () => {
    await getAllData();
  }, []);

  const getAllData = async () => {
    try {
      const data = await getAllImagesAndUrl();
      setshowHelper(data.status);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!otpVerified || otpExpiresAt <= 0) return;

    const interval = setInterval(() => {
      const remaining = otpExpiresAt - Math.floor(Date.now() / 1000);
      if (remaining <= 0) {
        setOtpVerified(false);
        setOtpId("");
        setOtpExpiresAt(0);
        setOtpValue("");
        setOtpAttempts(0);
        setOtpInvalid(false);
      } else {
        setTimerTick((prev) => prev + 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [otpVerified, otpExpiresAt]);

  return (
    <form
      noValidate
      onSubmit={
        masterAdminCheck ? masterFormik.handleSubmit : formik.handleSubmit
      }
    >
      <Grid container display="grid" spacing={4}>
        <Grid item xs={12}>
          <Typography variant="h3" paddingBottom={1}>
            {masterAdminCheck ? "Master login" : "Welcome back"}
          </Typography>
          <Typography variant="body1">{mailId}</Typography>
        </Grid>
        {masterAdminCheck && (
          <Grid item xs={12} spacing={10}>
              <>
                <TextField
                  value={masterFormik.values.username}
                  onChange={(e) => {
                    masterFormik.setFieldValue("username", e.target.value);
                    if (invalid) setInvalid(false);
                  }}
                  fullWidth
                  type={"text"}
                  onBlur={masterFormik.handleBlur}
                  name="username"
                  id="username"
                  sx={{ marginBottom: "1rem" }}
                  autoFocus
                  error={
                    (masterFormik.touched.username &&
                      Boolean(masterFormik.errors.username)) ||
                    invalid
                  }
                  helperText={
                    (masterFormik.touched.username &&
                      masterFormik.errors.username) ||
                      (invalid && authErrorMessage) ||
                    (invalid && "Invalid master email")
                  }
                  label="Master email"
                ></TextField>
                <TextField
                  value={masterFormik.values.passw}
                  onChange={(e) => {
                    masterFormik.setFieldValue("passw", e.target.value);
                    if (invalid) setInvalid(false);
                  }}
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  onBlur={masterFormik.handleBlur}
                  name="passw"
                  id="passw"
                  error={
                    (masterFormik.touched.passw &&
                      Boolean(masterFormik.errors.passw)) ||
                    invalid
                  }
                  helperText={
                    (masterFormik.touched.passw && masterFormik.errors.passw) ||
                    (invalid && authErrorMessage) ||
                    (invalid && "Invalid master password")
                  }
                  label="Master password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
              </>
          </Grid>
        )}
        {!masterAdminCheck && (
          <Grid item xs={12}>
            <TextField
              value={formik.values.passw}
              onChange={(e) => {
                formik.setFieldValue("passw", e.target.value);
                if (invalid) setInvalid(false);
                if (invalidLogin) setInvalidLogin(false);
                if (authErrorMessage) setAuthErrorMessage("");
              }}
              fullWidth
              type={showPassword ? "text" : "password"}
              onBlur={formik.handleBlur}
              name="passw"
              id="passw"
              autoFocus
              error={
                (formik.touched.passw && Boolean(formik.errors.passw)) ||
                invalid ||
                invalidLogin
              }
              helperText={
                (formik.touched.passw && formik.errors.passw) ||
                (invalid && authErrorMessage) ||
                (invalid && "Invalid password") ||
                (invalidLogin && "Invalid login hours")
              }
              label="Password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setShowPassword(!showPassword);
                      }}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            ></TextField>
          </Grid>
        )}
        {showHelper !== "ENABLED" && !masterAdminCheck && (
          <Grid item xs={12}>
            <Link
              underline="hover"
              component={DomLink}
              to={{
                pathname: masterAdminCheck
                  ? "/masterAdmin/forget-password"
                  : "/auth/forget-password",
                state: {
                  email: mailId,
                },
              }}
            >
              {" "}
              Forgot your password?{" "}
            </Link>
          </Grid>
        )}
        {window.location.hostname === "pms.isha.in" && (
          <Grid item xs={12}>
            <Link
              underline="hover"
              component={DomLink}
              to={{
                pathname: masterAdminCheck
                  ? "/masterAdmin/forget-password"
                  : "/auth/forget-password",
                state: {
                  email: mailId,
                },
              }}
            >
              {" "}
              Forgot your password?{" "}
            </Link>
          </Grid>
        )}
        {/* OTP Field - Shows for Master Admin OR Hotel V2 */}
        {otpVerified && (
          <>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="otp"
                id="otp"
                label="Enter OTP"
                value={otpValue}
                onChange={(e) => {
                  setOtpValue(e.target.value);
                  if (otpInvalid) setOtpInvalid(false);
                }}
                error={otpInvalid}
                helperText={
                  otpInvalid
                    ? otpAttempts >= 3
                      ? "Too many failed attempts. Please try again."
                      : `Invalid OTP. ${3 - otpAttempts} attempts remaining.`
                    : ""
                }
                autoFocus
                sx={{ marginBottom: "1rem" }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body2"
                color={
                  formatDisplayTimeForOtpEpoch(otpExpiresAt) === "0:00"
                    ? "error"
                    : "textSecondary"
                }
                align="center"
                sx={{ marginBottom: "1rem" }}
              >
                {timerTick && formatDisplayTimeForOtpEpoch(otpExpiresAt)}
              </Typography>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <LoadingButton
            sx={{ height: "150%" }}
            loading={otpVerified ? otpLoading : loading}
            type={otpVerified ? "button" : "submit"}
            onClick={otpVerified ? handleOtpSignIn : undefined}
            fullWidth
            variant="custom-button"
            size="large"
          >
            {(masterAdminCheck || (!masterAdminCheck && isV2AuthEnabled)) && otpVerified
              ? "Sign In"
              : (masterAdminCheck || (!masterAdminCheck && isV2AuthEnabled))
              ? "Verify with Email OTP"
              : "Sign In"}
          </LoadingButton>
        </Grid>
        <Grid item container justifyContent="center" xs={12}>
          <Link onClick={loginTrue} underline="hover" to="/">
            {" "}
            Back{" "}
          </Link>
        </Grid>
      </Grid>
    </form>
  );
};

export default injectIntl(connect(null, auth.actions)(EmailSuccess));
